/** @format */

import React from 'react';
import I18n from '../../Translate/I18n';

interface CardBoxDescriptionInterface {
    classes: any;
    description: string;
}

const CardBoxDescription = (props: CardBoxDescriptionInterface): React.ReactElement => {
    return (
        <div className={props.classes.cardBoxDescription}>
            <I18n trans={props.description} />
        </div>
    );
};

export default CardBoxDescription;
